export default __webpack_public_path__ + "static/hero-b4fdbd599b3e0a111b4dcb65bc5f4970.png";